var map = {
	"./agency-panel/ideamotive-logo": 5,
	"./agency-panel/ideamotive-logo.png": 5,
	"./background-circles": 6,
	"./background-circles.jpg": 6,
	"./brief-success/success-envelope": 7,
	"./brief-success/success-envelope.svg": 7,
	"./briefly_logo24": 8,
	"./briefly_logo24.svg": 8,
	"./briefly_logo24_transparent_white": 9,
	"./briefly_logo24_transparent_white.svg": 9,
	"./dark-circles": 10,
	"./dark-circles.jpg": 10,
	"./favicon/favicon.ico": 59,
	"./header-bg_photo": 11,
	"./header-bg_photo.jpg": 11,
	"./icons/file_attachment": 1,
	"./icons/file_attachment.png": 1,
	"./icons/file_attachment.svg": 60,
	"./icons/file_attachment@2x": 12,
	"./icons/file_attachment@2x.png": 12,
	"./icons/icon-product_1": 13,
	"./icons/icon-product_1.svg": 13,
	"./icons/icon-product_2": 14,
	"./icons/icon-product_2.svg": 14,
	"./icons/icon-product_3": 15,
	"./icons/icon-product_3.svg": 15,
	"./icons/icon-product_4": 16,
	"./icons/icon-product_4.svg": 16,
	"./icons/icon-product_5": 17,
	"./icons/icon-product_5.svg": 17,
	"./icons/icon-product_6": 18,
	"./icons/icon-product_6.svg": 18,
	"./icons/icon-product_7": 19,
	"./icons/icon-product_7.svg": 19,
	"./icons/icon-product_8": 20,
	"./icons/icon-product_8.svg": 20,
	"./icons/logo_missing": 2,
	"./icons/logo_missing.png": 2,
	"./icons/logo_missing.svg": 61,
	"./icons/logo_missing@2x": 21,
	"./icons/logo_missing@2x.png": 21,
	"./landing/background-circles": 22,
	"./landing/background-circles.jpg": 22,
	"./landing/dark-circles": 23,
	"./landing/dark-circles.jpg": 23,
	"./landing/header-bg_photo": 24,
	"./landing/header-bg_photo.jpg": 24,
	"./login/login-photo": 25,
	"./login/login-photo.png": 25,
	"./logo_briefly24_beta": 26,
	"./logo_briefly24_beta.png": 26,
	"./manage-offer/choose-agency": 27,
	"./manage-offer/choose-agency.jpg": 27,
	"./manage-offer/edit": 28,
	"./manage-offer/edit.png": 28,
	"./manage-offer/file": 29,
	"./manage-offer/file.png": 29,
	"./manage-offer/folder": 30,
	"./manage-offer/folder.png": 30,
	"./manage-offer/ideamotive-logo": 31,
	"./manage-offer/ideamotive-logo.png": 31,
	"./manage-offer/information": 32,
	"./manage-offer/information.png": 32,
	"./manage-offer/paperclip": 33,
	"./manage-offer/paperclip.png": 33,
	"./manage-offer/puzzle_illustration": 34,
	"./manage-offer/puzzle_illustration.svg": 34,
	"./oval-dashed_line": 35,
	"./oval-dashed_line.svg": 35,
	"./social_briefly24": 36,
	"./social_briefly24.png": 36
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58;